import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';

import Skeleton from '@material-ui/lab/Skeleton';

import { DIMENSIONS } from '../../../styles/constants';
import { useStyles } from './styles';
import Paper from '../../Paper';

const TableSkeleton = ({ numberOfRows }) => {
	const classes = useStyles();
	const theme = useTheme();

	return (
		<Paper>
			<div className={classes.tableBar}>
				<Skeleton width="100%" height={DIMENSIONS.SKELETON_BUTTON_HEIGHT} />
			</div>

			{[...Array(numberOfRows)].map((_e, index) => (
				<div key={'select-table-skeleton-row-' + index} className={classes.tableRow}>
					<Skeleton width={`calc(100% - ${theme.spacing(3)})px`} height="100%" className={classes.skeleton} />
				</div>
			))}

			<div className={classes.tableBar}>
				<Skeleton width="100%" height={DIMENSIONS.SKELETON_TITLE_HEIGHT} />
			</div>
		</Paper>
	);
};

TableSkeleton.propTypes = {
	numberOfRows: PropTypes.number.isRequired,
	withFooter: PropTypes.bool
};

export default TableSkeleton;
